import React from 'react';
import { useSelector } from 'react-redux';
import Helmet from 'react-helmet';
import { Redirect } from 'react-router-dom';
import Layout from '../../shared/components/Layout/Layout';
import PlannerPage from './components/PlannerPage';

/**
 * Planner Module
 *
 * Main entry point for the planner feature.
 * Provides calendar-based planning with Plan and Review modes.
 */
const Planner = () => {
  const currentUser = useSelector((state) => state.auth.data.currentUser);

  // Guard access: only coaches (admin flag truthy) should see Planner.
  // Athletes hit workouts instead; wait for admin to resolve to avoid early redirects.
  const adminStatus = currentUser?.admin;
  const hasResolvedRole = typeof adminStatus === 'number';

  if (hasResolvedRole && adminStatus === 0) {
    return <Redirect to='/workouts' />;
  }

  return (
    <Layout fullWidth>
      <Helmet>
        <title>The Planner | TeamBuildr</title>
      </Helmet>
      <PlannerPage currentUser={currentUser} />
    </Layout>
  );
};

export default Planner;
